import Vue from "vue";
import Router from "vue-router";
import home from "@/pages/home/index"; //首頁
import index from "@/pages/index/index"; //排行
import detail from "@/pages/detail/detail"; //排行

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/home",
      name: "home",
      component: home,
      meta: {
        keepAlive: true,
        title: ""
      }
    },
    {
      path: "/detail",
      name: "detail",
      component: detail,
      meta: {
        title: ""
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js